import * as React from 'react';
import { Linked, useModel } from '@type-r/react';
import { InvoiceModel } from 'api/invoice';
import { CompactTextArea } from 'lqx-react/src';
import { Events } from '@type-r/models';
import { SocDialog } from './socDialog';
import { Activity } from 'api/activity';
import { localUserInfo } from 'api';
import { SocCompactInvoices } from './socCommon';

export const CommentDialog = (props: {
    $isOpen: Linked<boolean>,
    invoices: InvoiceModel[],
}) => {
    const invoices = props.invoices;
    const invoiceCommentActivity = useModel(Activity);

    React.useEffect(() => {
        invoiceCommentActivity.$.type.set('Invoice_CommentAdded');
    }, []);

    const addComment = async () => {
        if (invoices && invoices.length) {
            let activities = invoices.map(i => {
                const activity = invoiceCommentActivity.clone();
                activity.assetId = i.id;
                activity.relationshipId = localUserInfo.getRelationshipId(i.conversationId);
                return activity;
            });
            await Activity.saveActivities(activities, 'Invoice');
        }
    }

    return <SocDialog
        {...props}
        dialogType="comment"
        doIO={addComment}
        onSuccess={() => Events.trigger("Soc:commentAdded")}
        isValid={() => !!invoiceCommentActivity.$.comment}
        child={
            <>
                <CompactTextArea label="Comments" $value={invoiceCommentActivity.$.comment} />
                <SocCompactInvoices title={'Invoices to be updated'} invoices={invoices}></SocCompactInvoices>
            </>
        }
    />
}
